<template>


<div class="text-white flex-1 col-span-1 border-0 rounded-t-xl">
  <div class="bg-theme-green px-4 py-2 text-white rounded-t-xl">
    <div class="flex justify-between items-center">
      <h2 class="font-bold truncate text-single-line break-all leading-tight text-2xl mt-0 mr-2">{{ form.action_name.value ? form.action_name.value : 'New Action'}}</h2>
      <div class="flex items-center content-center">
        <button @click="save()" class="text-sm cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3">
            <span>SAVE</span>
        </button>
        <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-2  hover:opacity-70">CLOSE</span>
        <!-- <mdicon @click.prevent="clearComponent" size="32" name="close" class="cursor-pointer hover:opacity-60 text-4xl ml-4"/> -->
      </div>
    </div>
  </div>


  <div class="bg-[#2B2C32] px-[16px] py-[12px] rounded-b-lg">
    <div class="flex items-center xl:flex-row flex-col gap-2 my-2">   
      <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper relative ' + (form.action_name.error_type)">
            <label class="text-xs tracking-[0.4px] mt-1.5">Action Name</label>
            <input placeholder="Name" @keyup="validateFields(['action_name'])" v-model="form.action_name.value" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="text">  
            <p class="field-error label-text mt-1" v-if="form.action_name.error_message" v-text="form.action_name.error_message"></p>
          </div>
      </div>
      <div class="w-full xl:w-1/2">
          <div :class="'input-wrapper relative ' + (form.action_key.error_type)">
              <label class="text-xs tracking-[0.4px] mt-1.5">Action Type</label>
              <select @change="validateFields(['action_key'])" v-model="form.action_key.value" name="action-type" class="block tracking-wider border-none rounded bg-gray-black w-full text-white text-sm">
                 <option disabled value="">Select</option>
                <option v-bind:key="'actionTyoe'+action.value" :value="action.value" v-for="action in actionType">{{ action.text }}</option>
              </select>
              <p class="field-error label-text mt-1" v-if="form.action_key.error_message" v-text="form.action_key.error_message"></p>
          </div>
      </div>
    </div>

    <div class="flex items-center xl:flex-row flex-col gap-2 my-2">   
      <div class="w-full">
          <div :class="'input-wrapper relative ' + (form.desc.error_type)">
            <label class="text-xs tracking-[0.4px] mt-1.5">Description</label>
            <textarea placeholder="Name" @keyup="validateFields(['desc'])" v-model="form.desc.value" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm"></textarea>  
            <p class="field-error label-text mt-1" v-if="form.desc.error_message" v-text="form.desc.error_message"></p>
          </div>
      </div>
    </div>

    <div class="flex gap-2 xl:flex-row flex-col pb-2">   
      <div class=" w-full">
        <div :class="'input-wrapper relative clearable ' + (form.start_date.error_type)">
          <label class="text-xs tracking-[0.4px]">Start Date</label>
          <div class=" bg-gray-black rounded w-full flex items-center">
              <span class="ml-2 mr-2">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white"/>
                </svg>
              </span>
          <Datepicker :clearable="true" :inputFormat='"yyyy-MM-dd"' :lowerLimit="new Date()" v-model="form.start_date.value" class="block  focus:outline-none tracking-wider border-none rounded pl-4  bg-gray-black w-full text-sm placeholder-theme-878686" placeholder="Select a Date"  />
         
        </div>
         <p class="field-error label-text mt-1" v-if="form.start_date.error_message" v-text="form.start_date.error_message"></p>
        </div>
      </div>
      <div class="w-full">
        <div :class="'input-wrapper relative clearable ' + (form.end_date.error_type)">
          <label class="text-xs tracking-[0.4px]">End Date</label>
          <div class=" bg-gray-black rounded w-full flex items-center">
              <span class="ml-2 mr-2">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white"/>
                </svg>
              </span>
          <Datepicker :clearable="true" :inputFormat='"yyyy-MM-dd"' :lowerLimit="endDateLimit" v-model="form.end_date.value" class="block tracking-wider focus:outline-none border-none rounded pl-4  bg-gray-black w-full text-sm placeholder-theme-878686" placeholder="Select a Date"  />
          
          </div>
          <p class="field-error label-text mt-1" v-if="form.end_date.error_message" v-text="form.end_date.error_message"></p>
        </div>
      </div>
    </div>
    <div class="flex items-center xl:flex-row flex-col gap-2 my-2">   
      <div class="w-full xl:w-1/2">
        <label class="text-xs tracking-[0.4px]">Is Active</label>
          <label class="flex items-center cursor-pointer" @click.prevent="form.is_active = !form.is_active">
            <input type="checkbox" v-model="form.is_active" class="hidden peer">
            <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.is_active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
            <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.is_active ? 'text-theme-green' : 'text-[#F53333]'">{{form.is_active ? 'ON' : 'OFF'}}</span>
          </label>
      </div>
      <div class="w-full xl:w-1/2">
        <div :class="'input-wrapper ' + (form.earn_value.error_type)">
          <label class="text-xs tracking-[0.4px]">Point Value</label>
          <div class="relative">
            <input placeholder="1,500" @keyup="validateFields(['earn_value'])"  v-model="form.earn_value.value" class="block tracking-wider border-none pr-[100px] rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="number">
            <span class="absolute bottom-1 right-2 text-base font-bold tracking-wider border border-theme-green rounded text-theme-878686 py-[1px] w-[110px] text-center px-[3px] truncate">$ {{ pointToCash }}</span>
          </div>
          <p class="field-error label-text mt-1" v-if="form.earn_value.error_message" v-text="form.earn_value.error_message"></p>
        </div>
      </div>
    </div>

   

    <!-- extra 2-->
    <div class="flex items-center xl:flex-row flex-col gap-2 my-2" v-if="appStore.includes(form.action_key.value)">   
      <div class="w-full xl:w-1/2">
        <div :class="'input-wrapper ' + (form.max_per_user.error_type)">
          <label class="text-xs tracking-[0.4px] mt-1.5">Max Per User</label>
          <input placeholder="Max Per User" @keyup="validateFields(['max_per_user'])" :onkeypress="preventNonNumbersAndDecimal" v-model="form.max_per_user.value" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="number">  
          <p class="field-error label-text mt-1" v-if="form.max_per_user.error_message" v-text="form.max_per_user.error_message"></p>
        </div>
      </div>
      <div class="w-full xl:w-1/2">
        <div :class="'input-wrapper ' + (form.daily_max_per_user.error_type)">
          <label class="text-xs tracking-[0.4px] mt-1.5">Daily Max Per User</label>
          <input placeholder="Max Per User" @keyup="validateFields(['daily_max_per_user'])" :onkeypress="preventNonNumbersAndDecimal" v-model="form.daily_max_per_user.value" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="number">  
          <p class="field-error label-text mt-1" v-if="form.daily_max_per_user.error_message" v-text="form.daily_max_per_user.error_message"></p>
        </div>
      </div>
    </div>


     <!-- extra 1-->
    <div class="flex items-center xl:flex-row flex-col gap-2 my-2" v-if="form.action_key.value === 'app_store_checkin_bonus'">   
      <div class="w-full xl:w-1/2">
        <div :class="'input-wrapper ' + (form.session_limit_minutes.error_type)">
          <label class="text-xs tracking-[0.4px] mt-1.5">Session Limit in Minutes</label>
          <input placeholder="Session Time" @keyup="validateFields(['session_limit_minutes'])" v-model="form.session_limit_minutes.value" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="number">  
          <p class="field-error label-text mt-1" v-if="form.session_limit_minutes.error_message" v-text="form.session_limit_minutes.error_message"></p>
        </div>
      </div>
      <div class="w-full xl:w-1/2">
      </div>
    </div>


  </div>
</div>

</template>


<script>
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import Datepicker from 'vue3-datepicker'
import moment from 'moment';
import LoyaltyProgramActionApis from "@/controllers/LoyaltyProgramActionApis";

export default defineComponent({
  name: "MembershipProgramEarningPointsAdd",
  components: {
    Datepicker
  },
  props:{
    clearComponent: {
      type: Function,
      required: true,
    },
    redeemingSetting: {
      type: Object,
      required: true,
    },
    loyaltyProgram: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const snackbar = useSnackbar();
    const form = ref({

      action_name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      action_key: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      desc: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      start_date: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      end_date: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
     // auto_apply: true,
      is_active: false,
     // action_trigger: null,
    //  action_condition: {},
      max_per_user: {
        value: 0,
        error_type: '',
        error_message: '',
        validations: ['required', 'number', 'maxval:9999999'],
      },
      daily_max_per_user: {
        value: 0,
        error_type: '',
        error_message: '',
        validations: ['required', 'number', 'maxval:9999999'],
      },
      earn_type: 'fixed',
      earn_value: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'number', 'maxval:99999'],
      },
      image_url: '',
      session_limit_minutes: {
        value: 60,
        error_type: '',
        error_message: '',
        validations: ['required', 'number', 'maxval:99999'],
      }
    });

    const actionType  = ref([
        { text: 'Sign Up', value: 'signup' },
        { text: 'Checkout', value: 'checkout' },
        { text: 'Birthday', value: 'birthday' },
        { text: 'Referral', value: 'referral' },
        { text: 'Check-in', value: 'app_store_checkin_bonus' },
        { text: 'Delivery Order', value: 'app_store_checkout_delivery_bonus' },
        { text: 'Pickup Order', value: 'app_store_checkout_pickup_bonus' },
        { text: 'Instore Order', value: 'instore_order' },
        // { text: 'Pickup Bonus', value: 'app_store_checkout_takeout_bonus' },
    ]);

    const appStore = ref([
      'app_store_checkout_takeout_bonus',
      'app_store_checkin_bonus',
      'app_store_checkout_delivery_bonus',
      'app_store_checkout_pickup_bonus',
      'checkout',
      'referral',
      'instore_order'
    ]);

    const actionTrigger = ref([
      { text: 'App', value: 'app' },
      { text: 'Instore order', value: 'instore_order' },
      { text: 'Check In', value: 'checkin' },
      { text: 'Checkout', value: 'checkout' },
      { text: 'Ecommerce order', value: 'ecommerce_order' },
      { text: 'Transaction count', value: 'transaction_count' }
    ]);

    const  earnType = ref(['fixed', 'incremental', 'percentage']);
    return {
      form,
      snackbar,
      actionType,
      appStore,
    };
  },

  watch:{
    'form.action_key.value'(val) {
      if (val === 'signup') {
        this.form.desc.value = 'A new user joining your membership program will be awarded the specified amount of points'
      } else if (val === 'app_store_checkin_bonus') {
        
        this.form.desc.value = 'Opening the in store version of the Tendy site will award the user the specified amount of points up to a number of times limited as you set'
      } else {
        this.form.desc.value = ``;
      }
    },
    // Do not let add more than 5 numbers count
    'form.earn_value.value'(val, old) {
      if(val.toString().length > 7){
        this.form.earn_value.value = old;
      }
    },

    'form.start_date.value'() {
      this.validateFields(['start_date']);
      if(this.form.end_date.value != '') {
        // then need to check
        let endDate = moment(this.form.end_date.value);
        let startDate = moment(this.form.start_date.value);
        let dayGap = endDate.diff(startDate, 'day');
        if(dayGap < 0) {
          this.snackbar.add({
            type: 'info',
            text: 'End date must be equal or greater than start date.',
            duration: 3000,
          })
          this.form.end_date.value = '';
        }
      }
    },
    'form.end_date.value'() {
      this.validateFields(['end_date']);
    },

  },

  computed: {
    
    pointToCash() {
      
      let val = this.form.earn_value.value ;
      
      if(!this.form.earn_value.value || !this.redeemingSetting.points_for_dollar) {
        return  0.00.toFixed(2);
      }
      
      if(this.form.earn_value?.value && this.redeemingSetting?.points_for_dollar) {
        return (Math.round(this.form.earn_value.value / this.redeemingSetting.points_for_dollar * 100) / 100).toFixed(2)
      }
      return 0.00.toFixed(2);
    },
    
    endDateLimit() {
      return this.form.start_date?.value ?  moment(this.form.start_date.value).toDate() : new Date();
    },
    ...mapGetters({
      vg_selectedBusiness: 'auth/activeBusiness',
    }),
  },

  mounted() {
     
  },
 
  methods: {
     /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    /**
     * Save
     */
    async save() {
      // validate business field
      let validate = await this.validateFields(['action_name', 'action_key', 'earn_value', 'desc', 'start_date' , 'end_date']);
      if(!validate) {
        return ;
      }
      let data = Helpers.getFormKeyValue(this.form);
      
      if (this.appStore.includes(data.action_key)) {
          data.max_per_user = parseInt(data.max_per_user)
          data.daily_max_per_user = parseInt(data.daily_max_per_user)
          data.session_limit_minutes = parseInt(data.session_limit_minutes)
          if (data.action_key === 'app_store_checkin_bonus') {
            data.action_trigger = 'checkin'
          } else if (data.action_key === 'referral') {
            data.action_trigger = 'referral'
          } else if (data.action_key === 'instore_order') {
            data.action_trigger = 'checkout_instore'
          } else if (data.action_key === 'app_store_checkout_delivery_bonus') {
            data.action_trigger = 'checkout_delivery'
          } else if (data.action_key === 'app_store_checkout_pickup_bonus') {
            data.action_trigger = 'checkout_pickup'
          } else {
            data.action_trigger = 'checkout'
          }
      } else {
        data.action_trigger = null;
      }

      if(data.start_date) {
        data.start_date = data.start_date ? moment(data.start_date).format('YYYY-MM-DD') :  null;
       
      } else {
        delete data['start_date']; 
      }
     

      if(data.end_date) {
        data.end_date = data.end_date ? moment(data.end_date).format('YYYY-MM-DD') :  null;
       
      } else {
        delete data['end_date']; 
      }
    
      data.action_condition = {};
    

      this.va_spinner(true);
      let res = await LoyaltyProgramActionApis.triggerAction( { 
        program_id: this.loyaltyProgram.id, 
        data: data 
      })
      if(res.status == 201 ) {
        this.clearComponent();
        this.emitter.emit("refresh-earningpoints-list", true);
      }
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },


    /**
     * 
     *  Do not allow to add +,-,e ,. 
     */
    preventNonNumbersAndDecimal(e) {
      var ASCIICode = (e.which) ? e.which : e.keyCode
      if (ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101 || e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
      }
      return true;
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>